import Wrapper from './Wrapper';
import {useDialoguesContext} from './Provider';

const DialoguesWrapper = Wrapper;
export default DialoguesWrapper;

export {
    useDialoguesContext as useDialogues,
}